import { signInWithCustomToken, type Auth, getAuth } from 'firebase/auth'
export const handleAuthToken = async (authToken: string) => {
  try {
    const userStore = useUserStore()
    const navigationStore = useNavigationStore()

    const { $api } = useNuxtApp()
    const { signOut } = useAuth()
    try {
      await $api.auth.deleteSession()
      await signOut()
    } catch (error) {
      console.log(error)
    }

    navigationStore.$reset()
    userStore.$reset()
    $api.setToken(authToken)
    userStore.saveFromToken(authToken)
    navigationStore.setEmbedContext()
  } catch (e) {
    console.error(e, 'Auth Token Error')
  }
}
